export const APPOINTMENT_COOKIE_NAME = "aspen_appointment";

/**
 * Shape of the aspen_appointment cookie value.
 *
 * Encoding: encodeURIComponent(JSON.stringify(value))
 * Decoding: JSON.parse(decodeURIComponent(rawCookieValue))
 *
 * appointmentDate — "EEEE, MMMM d, yyyy" e.g. "Wednesday, August 13, 2025"
 * appointmentTime — uppercase h:mm AM/PM   e.g. "9:00 AM"
 */
export interface AppointmentCookie {
  firstName: string;
  appointmentDate: string;
  appointmentTime: string;
}
